import { patchSchema } from '@takeshape/schema';
import { updateSchema } from 'app/branches/actions';
import type { ProjectSchemaCompat } from 'app/compat/types';
import type { SagaIterator } from 'redux-saga';
import { call, select, takeLatest } from 'redux-saga/effects';
import { getRoutineSaga } from '../../common/utils/new-sagas.js';
import { setProjectEndpoint } from '../../graphql-client.js';
import { type SchemaUpdate, updateSchemaMutation } from '../api.js';
import { getBranchQueryArgs, getUserSchema } from '../selectors.js';
import type { BranchQueryArgs } from '../types.js';

export function* updateSchemaSaga(payload: SchemaUpdate): SagaIterator {
  const branch: BranchQueryArgs = yield select(getBranchQueryArgs, {});
  const runtimeSchema: ProjectSchemaCompat = yield call(updateSchemaMutation, {
    ...payload,
    ...branch
  });
  const userSchema: ProjectSchemaCompat = yield select(getUserSchema);
  const updatedUserSchema = patchSchema(userSchema, payload);

  setProjectEndpoint(branch.projectId, branch.branchName, runtimeSchema.schemaHash);
  return { runtimeSchema, userSchema: updatedUserSchema };
}

export default function* root(): SagaIterator {
  yield takeLatest(updateSchema.requested, getRoutineSaga(updateSchema, updateSchemaSaga));
}
